import { Button, Center, Stack, Textarea } from "@chakra-ui/react"
import { ChangeEvent, FC, useCallback, useEffect, useState } from "react"

import FormattersApi from "@shared/api/formatters"
import useAllKeysPress from "@shared/hooks/useAllKeysPress"
import CodeBlock from "@shared/ui/code-block"
import ValidationIndicator from "@shared/ui/validation-indicator"

const placeholder = {
  name: "John",
  age: 18,
  uuid: "14b4afc1-8373-485e-ace7-cf76146fb2d3",
}

const JSONPretty: FC = () => {
  const [rawInput, setRawInput] = useState("")
  const [prettyOut, setPrettyOut] = useState("")
  const [isValid, setIsValid] = useState(false)
  const [isProcessed, setIsProcessed] = useState(false)

  const processPressed = useAllKeysPress({ userKeys: ["Control", "Enter"] })

  const handleSubmit = useCallback(async () => {
    const { result } = await FormattersApi.json(rawInput)

    if (!result) return

    setPrettyOut(JSON.stringify(result.json, null, 2))
    setIsValid(result.isValid)
    setIsProcessed(true)
  }, [rawInput])

  useEffect(() => {
    if (processPressed) {
      handleSubmit()
    }
  }, [processPressed, handleSubmit])

  const onChangeInput = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setRawInput(e.target.value)
  }

  return (
    <Stack>
      <Textarea
        placeholder={JSON.stringify(placeholder)}
        value={rawInput}
        onChange={onChangeInput}
        isInvalid={Boolean(rawInput && !isValid)}
        rows={8}
      />
      <Center>
        <Button onClick={handleSubmit} mt={2} disabled={!rawInput}>
          Process
        </Button>
      </Center>
      {isProcessed && (
        <>
          <ValidationIndicator isValid={isValid} />
          {isValid && <CodeBlock code={prettyOut} language={"json"} />}
        </>
      )}
    </Stack>
  )
}

export default JSONPretty
